<div class="container" *ngIf="idAto && visaoAto && exibirTela">
    <div class="conteudo-ato">
        <table style="width: 100%">
            <tr>
                <td width="*">
                    <div class="epigrafe-ato" [class]="obterTema()">
                        <span class="texto">{{ visaoAto.epigrafe.tipoAto.nomeTipoAto }}</span>
                        <span *ngFor="let orgao of visaoAto.epigrafe.orgaos; let i=index">
                            <span class="texto" title="{{ orgao.nomeOrgao }}"> {{ orgao.siglaOrgao }}</span>
                            <span class="texto" *ngIf="i < visaoAto.epigrafe.orgaos.length - 1"> / </span>
                        </span>
                        <span class="texto"> nº {{ visaoAto.epigrafe.numeroAto }}</span>
                        <span class="texto">, de {{ visaoAto.epigrafe.dataAtoPorExtenso }}</span>
                        <span class="retificacao" *ngIf="visaoAto.ancorasRetificacaoEpigrafe.length > 0"
                            (mouseover)="exibirRetificacaoEpigrafe = true"
                            (mouseout)="exibirRetificacaoEpigrafe = false">
                            <em class="material-icons">info</em>
                            <div class="info-retificacao-epigrafe" *ngIf="exibirRetificacaoEpigrafe">
                                <ng-container
                                    *ngFor="let ancoraRetificacao of visaoAto.ancorasRetificacaoEpigrafe; let i=index">
                                    <p>
                                        <span class="topo">{{ ancoraRetificacao.texto }}</span><br>
                                        <span class="corpo">
                                            <b>De:</b> {{ visaoAto.epigrafesAnteriores[i] }}<br>
                                            <b>Para:</b> {{ visaoAto.epigrafesAnteriores[i+1] }}<br>
                                        </span>
                                    </p>
                                </ng-container>
                            </div>
                        </span>
                    </div>
                    <div class="titulo-publicacao" [class]="obterTema()">
                        {{ visaoAto.dadosPublicacao }}
                    </div>
                    <div class="visoes-novo nao-imprimivel" [class]="obterTema()">
                        <div>
                            <span *ngFor="let visao of visoes"
                                [class]="visaoSelecionada === visao ? 'visao-selecionada' : 'visao-nao-selecionada'"
                                [title]="'Exibir a visão ' + visao.textoExibido" (click)="mudarVisao(visao)">
                                {{ visao.textoExibido }}
                            </span>
                        </div>
                    </div>
                    <div *ngIf="exibirVisao && visaoAto && visaoSelecionada && visaoSelecionada !== visaoRelacional">
                        <div [class]="exibicaoPorData ? 'visao-por-data' : null">
                            <div *ngIf="exibicaoPorData" class="situacao-ato">Situação do ato em {{ data }}</div>
                            <app-exibir-visao 
                                [visaoAto]="visaoAto" 
                                [visaoSelecionada]="visaoSelecionada"
                                [urlFuncionalidade]="urlFuncionalidade" 
                                [exibirBotaoIrTopo]="true"
                                [exibirDatasVigencia]="exibirDatasVigencia"
                                [tipoConsulta]="tipoConsulta">
                            </app-exibir-visao>
                        </div>
                        <!-- aviso sijut -->
                        <div class="aviso-sijut">* Este texto não substitui o publicado oficialmente.</div>
                    </div>

                    <div *ngIf="visaoSelecionada === visaoRelacional && atoVisaoRelacional">
                        <app-visao-relacional [visaoRelacional]="atoVisaoRelacional" [urlFuncionalidade]="urlFuncionalidade"></app-visao-relacional>
                    </div>
                </td>
                <td class="nao-imprimivel" width="56px">
                    <div class="botoes-laterais" *ngIf="visaoSelecionada !== visaoRelacional" [class]="obterTema()">
                        <div class="botao" [title]="getTitleBotaoLateralExibirDataInicio()"
                            [class]="getClassBotaoLateralExibirDataInicio()"
                            (click)="clickBotaoLateralExibirDataInicio()">
                            <em class="material-icons">event_available</em>
                        </div>
                        <div class="botao" [title]="getTitleBotaoLateralConsultarPorData()"
                            [class]="getClassBotaoLateralConsultarPorData()"
                            (click)="clickBotaoLateralConsultarPorData()">
                            <em class="material-icons">event</em>
                            <ng-container *ngIf="exibicaoPorData">
                                <div class="dia">{{ dia }}</div>
                                <div class="mes">{{ mes }}</div>
                                <div class="ano">{{ ano }}</div>
                            </ng-container>
                        </div>
                        <button *ngIf="exibicaoPorData" class="botao-sair-visao-data" (click)="mudarVisao(visoes[0])">
                            <em title="Sair da visualização em uma data específica"
                                class="material-icons icone-sair-visao-data"> close </em>
                        </button>
                        <div class="popup-consulta-data" *ngIf="habilitaConsultar">
                            <form #form="ngForm" (ngSubmit)="clickBuscarPorData()" novalidate>
                                <div class="situacao-ato" style="margin-left: 0px">Consultar ato na data</div>
                                <div class="data-selecionada">
                                    <suite-rfb-date-picker name="novo" [(ngModel)]="dataSelecionada"
                                        [suiteRfbMinDate]="minDate" [suiteRfbMaxDate]="maxDate" [outsideClick]="true"
                                        [adaptivePosition]="true"
                                        [disabled]="!visaoAto.integro"></suite-rfb-date-picker>
                                </div>
                                <button type="submit" class="btn btn-consultar" title="Consultar">
                                    Consultar
                                </button>
                            </form>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</div>

<div class="visualizacao-sequencial" *ngIf="visaoAto && exibirLinksVisualizacaoSequencial">
    <div class="anterior" [class]="idAtoAnterior > 0 ? 'ativo' : 'inativo'"
            title="Visualizar ato anterior"
            (click)="visualizarAtoAnterior()">
        <i class="material-icons icon-24">keyboard_arrow_left</i>
    </div>
    <div class="posterior" [class]="idAtoProximo > 0 ? 'ativo' : 'inativo'"
            title="Visualizar ato seguinte"
            (click)="visualizarAtoPosterior()">
        <i class="material-icons icon-24">keyboard_arrow_right</i>
    </div>
    <div class="contador">
        {{ getContador() }}
    </div>
</div>

<div class="botoes-header-pagina nao-imprimivel">
    <a [href]="getUrlPaginaInicial()">
        <button class="botao-header-pagina">
            <i class="material-icons icon-24">home</i>
        </button>
    </a>
    <button class="botao-header-pagina" (click)="imprimir()">
        <i class="material-icons icon-24">print</i>
    </button>
</div>
